import React from "react";
import { connect } from "react-redux";
import { compose, withHandlers, withState } from "recompose";
import { reduxForm, Field } from "redux-form";
import { TextField } from "react-md";
import { get } from "lodash";

import Dialog from "./DialogWrap";
import FormTextField from "../form/TextField";
import * as Validation from "../form/Validation";

import { isEmail, isDomain } from "../../utils";

import Translate from "../../Atollon/Translation";
import {DebugElement} from "../../Atollon/debug";
import {newRequestWithInputAsStruct} from "../../actions/requestActions";
import {getMainTouchUrl} from "../../constants";

const STATE_DOMAIN_NAME = 0;
const STATE_DOMAIN_EMAIL = 1;
const STATE_ORGANIZATION_INFO = 2;

let thisFormData = {};


const SettingsNewOrganization = ({
  handleSubmit,
  data,
  state,
  setState,
  domain,
  setDomain,
  email,
  setEmail,
  fail,
  setFail
}) => (
  <Dialog
    title="Vytvořit účet organizace"
    name="SettingsNewOrganization"
    handleSubmit={handleSubmit}
    submitLabel={state === STATE_ORGANIZATION_INFO ? "Odeslat" : "Další"}
    onClose={() => {
      setState(STATE_DOMAIN_NAME);
      setDomain("");
      setEmail("");
      setFail(null);
    }}
    stornoLabel={state ? "Zpět" : undefined}
    stornoOnClick={
      state
        ? () => {
            setState(state - 1);
            setFail(null);
          }
        : undefined
    }
    className="medium"
  >
    <DebugElement text={"src/compoents/dialogs/SettingsNewOrganization.js"}/>
    {state == STATE_DOMAIN_NAME && (
      <div {...{ className: "url" }}>
        <p>{getMainTouchUrl()}</p>
        <TextField
            id={Translate( "SettingsNewOrganization-set-domain", "Vaše doména")}
          {...{
            label: Translate( "SettingsNewOrganization-set-domain", "Vaše doména" ),
            value: domain,
            onChange: value => setDomain(value)
          }}
        />
      </div>
    )}
    {state === STATE_DOMAIN_EMAIL && (
      <div {...{ className: "email" }}>
        <TextField
            id="overte_vlastnictvi_vasi_domeny"
          {...{
            label: "Ověřte vlastnictví Vaší domény",
            value: email,
            onChange: value => setEmail(value),
            className: "width-max-50"
          }}
        />
        <p>{`@${domain}`}</p>
      </div>
    )}
    {state === STATE_ORGANIZATION_INFO && (
      <div {...{ className: "flex-col" }}>
        <Field
          {...{
            component: FormTextField,
            label: "Název organizace",
            name: "name",
            validate: [Validation.required]
          }}
        />
        <Field
          {...{
            component: FormTextField,
            label: "Adresa",
            name: "address",
            validate: [Validation.required]
          }}
        />
        <Field
          {...{
            component: FormTextField,
            label: "Adresa 2",
            name: "address2",
            validate: [Validation.required]
          }}
        />
        <Field
          {...{
            component: FormTextField,
            label: "Město",
            name: "city",
            validate: [Validation.required]
          }}
        />
        <Field
          {...{
            component: FormTextField,
            label: "PSČ",
            name: "zip",
            validate: [Validation.required]
          }}
        />
      </div>
    )}
    {fail && <span className="invalid">{fail}</span>}
  </Dialog>
);

export default compose(
  connect(({ app: { user } }) => ({ user }), {newRequestWithInputAsStruct}),
  withState("state", "setState", STATE_DOMAIN_NAME),
  withState("fail", "setFail", null),
  withState("domain", "setDomain", ""),
  withState("email", "setEmail", ""),
  withHandlers({
    onSubmit: dialog => async (formData, dispatch, props) => {
      const {
        state,
        setState,
        domain,
        setDomain,
        user,
        email,
        setEmail,
        setFail,
        newRequestWithInputAsStruct
      } = props;

      if (state == STATE_DOMAIN_NAME) {
        if (!isDomain(domain)) {
          setFail("Zadejte platnou doménu.");
        } else {
          setState(
            get(user, "identifier") &&
            get(user, "identifier").replace(/^[^@]*@/, "") === domain
              ? STATE_ORGANIZATION_INFO
              : STATE_DOMAIN_EMAIL
          );
          setFail(null);
        }
      } else if (state === STATE_DOMAIN_EMAIL) {
        if (!isEmail(`${email}@${domain}`)) {
          setFail("Zadejte platný email.");
        } else {
          setState(STATE_ORGANIZATION_INFO);
          setFail(null);
        }
      } else {

          let myName = user.contact ? user.contact.firstName : "";
          let mySurname = user.contact ? user.contact.name : "";
          let myEmail = user.identifier;

          let bodyAsStruct = {
              "subject":"Create Organization Account",
              // "messageBody":"Please create organization 'www.seznam.cz' and set user with email 'Chmel, Miloš (chmel@atollon.com)' as the administrator of the organization.",
              "messageBody":`Please create organization '${props.domain}' and set user with email '${mySurname}, ${myName} (${myEmail})' as the administrator of the organization.`,
              "companyName":formData.name,
              "address1":formData.address,
              "address2":formData.address2,
              "region":formData.city,
              //"countryCode":"AF",
              "formIdentifier":"com.atollon.form.register",
              //"language":"en-GB",
              "recipients":[{"identifier":"admin"}],
              "customFields":[
                  {"name":"city","value":formData.city},
                  {"name":"hostName","value":props.domain},
                  {"name":"hostEmail","value":props.email}, // first part of email without @email, "touchtesterboss"},
                  //{"name":"industry","value":"1372000"}, TODO:
                  //{"name":"webAddress","value":"www.seznam.cz"}, TODO:
                  //{"name":"twitter","value":"twitter"}, TODO:
                  {"name":"zipCode","value":formData.zip}
                  ],
              "sender":myEmail,
              "pendingSide":"RECIPIENT",
              "status":"INITIAL",
              "type":"CREATE_PROVIDER"
          };
          /*
          bodyAsStruct.subject="Create Organization Account";
          bodyAsStruct.messageBody= `Please create organization '{$www.seznam.cz}' and set user with email '{$Chmel, Miloš (chmel@atollon.com)' as the administrator of the organization.`;
              "companyName":"organization name",
              "address1":"adress",
              "address2":"address two",
              "region":"city",
              "countryCode":"AF",
              "formIdentifier":"com.atollon.form.register",
              "language":"en-GB",
              "recipients":[{"identifier":"admin"}],
              "customFields":[{"name":"city","value":"city"},{"name":"hostName","value":"www.seznam.cz"},{"name":"hostEmail","value":"touchtesterboss"},{"name":"industry","value":"1372000"},{"name":"webAddress","value":"www.seznam.cz"},{"name":"twitter","value":"twitter"},{"name":"zipCode","value":"zip"}],
              "sender":"chmel@atollon.com",
              */

          // TODO: debug
          console.log(bodyAsStruct,formData,props);
          newRequestWithInputAsStruct(bodyAsStruct);


        setState(STATE_DOMAIN_NAME);
        setDomain("");
        setEmail("");
        setFail(null);
        dialog.closeDialog();
      }
    }
  }),
  reduxForm({
    form: "SettingsNewOrganizationForm",
    enableReinitialize: true
  })
)(SettingsNewOrganization);



// WEBPACK FOOTER //
// ./src/components/dialogs/SettingsNewOrganization.js